import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";

import React, { Component } from "react";
import PrismCode from "react-prism";
import TruncateString from "react-truncate-string";
import Slider from "rc-slider";
import Tooltip from "rc-tooltip";

import "./App.css";

const Handle = Slider.Handle;

const handle = props => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

const string1 =
  "It truncates long long long long long long long long long long long long long long long wherever you want!";

class App extends Component {
  state = {
    truncate: 50
  };

  onChangePercentage = truncate => {
    this.setState({ truncate });
  };

  render() {
    return (
      <div className="App">
        <h1>react truncate string</h1>

        <div className="container containerA">
          <TruncateString text={string1} truncateAt={this.state.truncate} />
        </div>
        <div className="container containerB">
          <TruncateString text={string1} truncateAt={this.state.truncate} />
        </div>
        <div className="container containerC">
          <TruncateString text={string1} truncateAt={this.state.truncate} />
        </div>
        <div className="container containerD">
          <TruncateString text={string1} truncateAt={this.state.truncate} />
        </div>
        <div className="container containerE">
          <TruncateString text={string1} truncateAt={this.state.truncate} />
        </div>
        <div className="container containerF">
          <TruncateString text={string1} truncateAt={this.state.truncate} />
        </div>
        <h2>Usage:</h2>
        <div>
          <PrismCode component="pre" className="language-javascript">
            {`<TruncateString text={myString}${
              this.state.truncate === 50
                ? ``
                : ` truncateAt={${this.state.truncate}}`
            } />`}
          </PrismCode>
        </div>
        <h3>Truncate at:</h3>

        <div className="App-slider">
          <Slider
            min={0}
            max={100}
            defaultValue={this.state.truncate}
            handle={handle}
            onChange={this.onChangePercentage}
          />
        </div>

        <div>
          <h1>
            <a href="https://codesandbox.io/s/xvv9r5ozo">CodeSandbox</a> |{" "}
            <a href="https://github.com/albinotonnina/react-truncate-string">
              GitHub
            </a>
          </h1>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js